import React, { useEffect, useState } from "react";
import { debug, sortObjectsByAlphabet } from "../utils";
import { connect } from "react-redux";
import * as urlService from "../view/urlService";
import { useHistory } from "react-router-dom";
import * as mlDetectionService from "./mlDetectionService";
import Select from 'react-select';

function ChooseDeviceIpField({ results = [] }) {

    const history = useHistory();
    const [selectedIp, setSelectedIp] = useState('all');

    useEffect(() => {
        mlDetectionService.list();
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [])
    
    const onChange = (selectedOption) => {
        const ip = selectedOption.value;
        setSelectedIp(ip);

        if (ip === 'all') {
            history.push({
                pathname: history.pathname,
                search: urlService.removeFilter('ip')
            })
            return;
        }

        const result = results.find(result => result.ip === ip);
        history.push({
            pathname: history.pathname,
            search: urlService.updateFilters('ip', result.ip)
        })
    }

    //remove duplicate values based on ip field
    const resultsFilter = results.filter(
        (obj, index, self) => index === self.findIndex((o) => o.ip === obj.ip)
    );

    //sorting results
    const resultsCopy = sortObjectsByAlphabet(resultsFilter, 'ip');

    const options = [
        { value: 'all', label: 'All Devices' },
        ...resultsCopy.map(result => ({ value: result.ip, label: result.ip }))
    ];

    return (
        <Select
            className="oct_selectsearch-v2"
            classNamePrefix="oct-selectsearchsub-v2"
            value={options.find(opt => opt.value === selectedIp) || options[0]}
            onChange={onChange}
            options={options}
            isSearchable={true}
            placeholder="All Devices"
        />
    );
}


function mapStateToProps(state) {
    debug("DetectionResults mapStateToProps", state);
    const mlDetectionPage = state.mlDetectionPage;
    return {
        results: mlDetectionPage.allResults
    };
}

export default connect(mapStateToProps)(ChooseDeviceIpField);
